// from https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid
function uuid() {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) => (+c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16));
}
/**
 * Pluralizes a word based on the count.
 * @param count - The number of items.
 * @param singularWord - The singular form of the word.
 * @param options - Options for the pluralization.
 * @param options.excludeNumber - Whether to exclude the number from the result.
 * @param options.useLocale - Whether to use the locale for the number.
 * @param options.pluralWord - The plural form of the word. This will override the default pluralization rules.
 * @returns The pluralized word.
 */
function pluralize(count, singularWord, { excludeNumber, useLocale, pluralWord, } = {}) {
    const base = excludeNumber
        ? ''
        : `${useLocale ? count.toLocaleString() : count} `;
    const vowels = ['a', 'e', 'i', 'o', 'u'];
    if (count === 1) {
        return base + singularWord;
    }
    if (pluralWord) {
        return base + pluralWord;
    }
    if (singularWord.endsWith('s') ||
        singularWord.endsWith('ch') ||
        singularWord.endsWith('sh') ||
        singularWord.endsWith('x') ||
        singularWord.endsWith('z')) {
        return base + singularWord + 'es';
    }
    if (singularWord.endsWith('y') &&
        !vowels.includes(singularWord.slice(-2, -1))) {
        return base + singularWord.slice(0, -1) + 'ies';
    }
    return base + singularWord + 's';
}

export { pluralize, uuid };
//# sourceMappingURL=str.js.map
